import { Button } from '../../components';
import React from 'react';
import { ChannelInfoService } from '../../services';
import warning from '../../assets/svg/warning.svg';
import '../Modal/Modal.global.scss';

interface Props {
  handleModalClose: any;
  id: any;
  fetchChannelList: any;
  status: any;
}
const ChannelManagementBlocked: React.FC<Props> = (props: Props) => {
  const {
    handleModalClose,
    id,
    fetchChannelList,
    status,
  } = props;

  const [blocked, setBlocked] = React.useState(false);
  const blockService = () => {
    ChannelInfoService.blockChannelApi(id, status === 'active' ? 'blocked' : 'active').then(() => {
      setBlocked(true);
    });
  };
  return (
    <>
      {!blocked ? (
        <>
          <div>
            <img src={warning} alt="warning" />
            <h2>
              {status === 'active' ? 'Block' : 'Unblock'}
              {' '}
              Channel
            </h2>
            <p>
              Are you sure you want to
              {' '}
              {status === 'active' ? 'block' : 'unblock'}
              {' '}
              this channel?
            </p>
            <div className="modalButtonWrapper">
              <Button onClick={handleModalClose}>No</Button>
              <Button intent={status === 'blocked' ? 'danger' : 'primary'} onClick={blockService}>Yes</Button>
            </div>
          </div>
        </>
      ) : (
        <>
          <h3>
            Channel
            {' '}
            {status === 'active' ? 'blocked' : 'unblocked'}
            {' '}
            successfully !
          </h3>
          <Button onClick={() => {
            handleModalClose();
            fetchChannelList({
              page: 0,
              rowsPerPage: 10,
            });
          }}
          >
            Ok
          </Button>
        </>
      )}

    </>
  );
};

export default ChannelManagementBlocked;
